var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg03N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9566 22.5716H10.1465C7.56431 22.5716 6.07812 20.9194 6.07812 18.8769C6.07812 17.1084 7.19899 15.7136 8.85954 15.2403C9.15014 11.9275 11.8734 9.42839 15.0949 9.42839C17.5608 9.42839 19.5867 10.7651 20.6909 12.9571C23.7048 12.9571 25.9217 15.0161 25.9217 17.7477C25.9217 20.4544 23.7546 22.5716 20.9566 22.5716Z",
    fill: "url(#paint0_linear_10214_640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_640",
    x1: 11.8022,
    y1: 12.3035,
    x2: 16.9323,
    y2: 27.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03N);
export default __webpack_public_path__ + "static/media/03n.8c9d4057c6074f1c005ba4d5a1d5a828.svg";
export { ForwardRef as ReactComponent };